import { useEffect, useRef } from 'react';
import { motion } from 'motion/react';

import styles from './Message.module.css';

import circle1 from '../../assets/images/circle1.png';
import circle2 from '../../assets/images/circle2.png';

const Message = ({ message, rotateSign, speed, randomDelay }) => {
  const videoRef = useRef(null);
  const initDelay = speed / 1000;

  const videoUrl = message.attachments?.[0]?.url;

  useEffect(() => {
    let idTimeout = '';
    if (videoRef.current) {
      idTimeout = setTimeout(() => {
        videoRef.current.play().catch((error) => {});
      }, speed + 600);
    } else if (idTimeout) {
      clearTimeout(idTimeout);
    }
    return () => {
      clearTimeout(idTimeout);
    };
  }, [initDelay]);

  return (
    <div
      className={styles.wrapper}
      style={{
        transform:
          rotateSign === '+' ? 'translateY(10rem)' : 'translateY(-8rem)',
      }}
    >
      <div className={styles.msg}>
        <div
          className={styles.circle}
          style={{ '--randomDelay': `${5.5 + randomDelay}s` }}
        >
          <motion.img
            initial={{ scale: 0, rotate: '277deg' }}
            animate={{ scale: 1, rotate: '0deg' }}
            transition={{
              scale: { duration: 0.64, delay: initDelay },
              rotate: { duration: 4.8, delay: initDelay },
            }}
            src={circle1}
            alt=""
            className={styles.circle1}
          />
          <motion.img
            initial={{ scale: 0, rotate: '-277deg' }}
            animate={{ scale: 1, rotate: '0deg' }}
            transition={{
              scale: { duration: 0.64, delay: initDelay + 0.32 },
              rotate: { duration: 4.8, delay: initDelay + 0.32 },
            }}
            src={circle2}
            alt=""
            className={styles.circle2}
          />

          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.6, delay: initDelay + 0.6 }}
            className={styles.msgVideo}
          >
            <video playsInline ref={videoRef} muted="muted" loop>
              <source src={videoUrl} type="video/webm" />
            </video>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Message;
